import React from 'react';
import Icon from 'components/Icon';

const Dropzone = ({ dropping }) => {
	// Do not render dropzone if dropping is not in progress
	if (!dropping) return null;

	return (
		<div className="browser__dropzone">
			<Icon icon="upload" className="browser__dropzoneIcon" />
			<h6>Nometiet failus šeit un tie tiks augšupielādēti!</h6>
		</div>
	);
};

export default Dropzone;